import { render, staticRenderFns } from "./FeedPage.vue?vue&type=template&id=57fc7ee4&scoped=true&"
import script from "./FeedPage.vue?vue&type=script&lang=js&"
export * from "./FeedPage.vue?vue&type=script&lang=js&"
import style0 from "./FeedPage.vue?vue&type=style&index=0&id=57fc7ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc7ee4",
  null
  
)

export default component.exports